import { ComponentPropsWithRef, InputHTMLAttributes, ReactNode } from "react";
import { clsx } from "clsx";
import styles from "./TextField.module.css";

type TextFieldProps = {
  icon?: ReactNode;
  variant?: "default" | "soft";
} & ComponentPropsWithRef<"input">;

export function TextField({ icon, variant = "default", className, ...props }: TextFieldProps) {
  return (
    <div data-variant={variant} className={clsx(styles.textFieldRoot, className)}>
      {icon}
      <input {...props} />
    </div>
  );
}
